import { render, staticRenderFns } from "./NoOnsCampaignBadge.vue?vue&type=template&id=0216295c&scoped=true&"
import script from "./NoOnsCampaignBadge.vue?vue&type=script&lang=js&"
export * from "./NoOnsCampaignBadge.vue?vue&type=script&lang=js&"
import style0 from "./NoOnsCampaignBadge.vue?vue&type=style&index=0&id=0216295c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0216295c",
  null
  
)

export default component.exports